module.exports = __webpack_public_path__ + "img/sqywk.3e26949f.png";